var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Chip, Paper, Popover, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { SingleFileUploadButton } from "../../../../shared/components/single-file-upload-button";
import { DeleteDialog } from "../../../../shared/components/delete-dialog";
import MyAccountDocumentsApi from "../api/my-account-documents-api";
import { ToDocumentRowViewModel } from "../../documents/api/dto/document-mapper";
import { UnderwriteComponent } from "../../documents/components/underwrite-component";
import WarningIcon from '@mui/icons-material/Warning';
import { MyAccountValidThrough } from "./doc-valid-through";
import { enqueueSnackbar } from "notistack";
import { errorSnackbar, successSnackbar } from "../../../../shared/snackbar-constants";
import { getErrorMessage } from "../../../../utilities/axios-utility";
export var DocumentListing = function (_a) {
    var leadId = _a.leadId;
    var documentsApi = new MyAccountDocumentsApi();
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), documents = _c[0], setDocuments = _c[1];
    var _d = useState(false), isDataChange = _d[0], setIsDataChange = _d[1];
    var _e = useState(false), isFileExists = _e[0], setIsFileExists = _e[1];
    var _f = React.useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var handlePopoverOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handlePopoverClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    useEffect(function () {
        documentsApi.GetAllDocuments(leadId)
            .then(function (response) {
            setIsFileExists(false);
            var documents = response.data.map(function (u) {
                if (u.uploadDate) {
                    setIsFileExists(true);
                }
                return ToDocumentRowViewModel(u);
            });
            setDocuments(documents);
            setLoading(false);
        })
            .catch(function () {
            setDocuments([]);
            setLoading(false);
            setIsFileExists(false);
        });
    }, [isDataChange]);
    var uploadDocument = function (formData, documentId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, documentsApi.UploadDocument(leadId, documentId, formData)];
                case 1:
                    _a.sent();
                    setIsDataChange(function (prevState) { return !prevState; });
                    enqueueSnackbar('Document uploaded', successSnackbar);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    enqueueSnackbar(getErrorMessage(error_1), errorSnackbar);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var deleteDocument = function (documentId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, documentsApi.DeleteDocument(leadId, documentId)];
                case 1:
                    _a.sent();
                    setIsDataChange(function (prevState) { return !prevState; });
                    enqueueSnackbar('Document deleted', successSnackbar);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    enqueueSnackbar(getErrorMessage(error_2), errorSnackbar);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var renderStatus = function (status) {
        switch (status) {
            case 0:
                return (_jsx(Chip, { label: "Not uploaded", color: "primary", variant: "outlined" }));
            case 1:
                return (_jsx(Chip, { label: "Pending Review", color: "warning" }));
            case 2:
                return (_jsx(Chip, { label: "Not approved", color: "error" }));
            case 3:
                return (_jsx(Chip, { label: "Approved", color: "success" }));
        }
    };
    var approvedCount = function () {
        return documents.filter(function (x) { return x.status === 3; }).length;
    };
    var receivedCount = function () {
        return documents.filter(function (x) { return x.uploadDate != ""; }).length;
    };
    var pendingCount = function () {
        return documents.filter(function (x) { return x.status === 1; }).length;
    };
    var renderNotarized = function (value) {
        return (value === true ?
            _jsxs("div", { children: [_jsxs(Typography, __assign({ "aria-owns": open ? 'mouse-over-popover' : undefined, "aria-haspopup": "true", onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose, style: {
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                        } }, { children: [_jsx("span", { children: "Yes" }), "\u00A0\u00A0", _jsx(WarningIcon, { color: "error" })] })), _jsx(Popover, __assign({ id: "mouse-over-popover", sx: {
                            pointerEvents: 'none',
                        }, open: open, anchorEl: anchorEl, anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        }, transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        }, onClose: handlePopoverClose, disableRestoreFocus: true }, { children: _jsx(Typography, __assign({ sx: { p: 1 } }, { children: "It is mandatory to provide notarized copy for this document" })) }))] })
            :
                _jsx(Typography, { children: "No" }));
    };
    return (_jsxs(Box, { children: [_jsx(Box, __assign({ sx: { textAlign: 'center' } }, { children: _jsxs(Stack, __assign({ direction: "row", display: "inline-flex", spacing: 2 }, { children: [_jsxs(Box, __assign({ sx: { color: 'success.main' } }, { children: ["\u25CF ", approvedCount(), " approved"] })), _jsxs(Box, __assign({ sx: { color: 'primary.main' } }, { children: ["\u25CF ", receivedCount(), " received"] })), _jsxs(Box, __assign({ sx: { color: 'warning.main' } }, { children: ["\u25CF ", pendingCount(), " pending"] }))] })) })), _jsx(TableContainer, __assign({ component: Paper }, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ align: "left", width: "20%" }, { children: "Document" })), _jsx(TableCell, __assign({ align: "left", width: "10%" }, { children: "Upload Date" })), _jsx(TableCell, __assign({ align: "left", width: "15%" }, { children: "Status" })), _jsx(TableCell, __assign({ align: "left", width: "5%" }, { children: "Notarized" })), _jsx(TableCell, __assign({ align: "left", width: "5%" }, { children: "Date Validation" })), _jsx(TableCell, __assign({ align: "left", width: "15%" }, { children: "Valid Through" })), _jsx(TableCell, __assign({ align: "left", width: "25%" }, { children: "Comment" })), _jsx(TableCell, __assign({ align: "left", width: "5%" }, { children: "Actions" }))] }) }), _jsxs(TableBody, { children: [(documents === null || documents === void 0 ? void 0 : documents.length) ?
                                    documents.map(function (document) {
                                        var _a;
                                        return (_jsxs(TableRow, { children: [_jsx(TableCell, __assign({ width: "20%" }, { children: document.kycDocumentName })), _jsx(TableCell, __assign({ width: "10%" }, { children: document.uploadDate ? "".concat(document.uploadDate) : 'Not uploaded yet' })), _jsxs(TableCell, __assign({ width: "15%" }, { children: [renderStatus(document.status), _jsx(UnderwriteComponent, { TextData: "Approved By: ".concat(document.approvedBy), date: document.approvedDate, status: document.status != 3 })] })), _jsx(TableCell, __assign({ width: "5%" }, { children: renderNotarized(document.notarized) })), _jsx(TableCell, __assign({ width: "5%" }, { children: document.dateValidation ? _jsx(Typography, { children: "Yes" }) : _jsx(Typography, { children: "No" }) })), _jsx(TableCell, __assign({ width: "15%" }, { children: _jsx(MyAccountValidThrough, { documentsProvider: documentsApi, documentId: document.leadKycDocumentId, validThrough: document.dateValidation, dateValidThrough: document.validThrough, setIsDataChange: setIsDataChange }) })), _jsxs(TableCell, __assign({ width: "25%" }, { children: [_jsx(Typography, __assign({ style: { wordWrap: "break-word" }, variant: 'caption' }, { children: document.comment })), _jsx(UnderwriteComponent, { TextData: "Last comment By: ".concat(document.commentedBy), date: document.commentDate, status: !((_a = document.comment) === null || _a === void 0 ? void 0 : _a.length) })] })), _jsx(TableCell, __assign({ width: "5%" }, { children: document.uploadDate
                                                        ?
                                                            _jsx(_Fragment, { children: _jsx(DeleteDialog, { alertTitle: 'Delete file?', alertText: 'Are you sure you want to delete file?', deleteAction: function () { return deleteDocument(document.leadKycDocumentId); } }) })
                                                        :
                                                            _jsx(SingleFileUploadButton, { id: document.leadKycDocumentId.toString(), onFileUpload: function (formData) { return uploadDocument(formData, document.leadKycDocumentId); } }) }))] }, document.kycId));
                                    })
                                    :
                                        _jsx(TableRow, { children: _jsx(TableCell, { children: loading ? 'Loading...' : 'No data to show' }) }), _jsx(TableRow, {})] })] }) }))] }));
};
